import React, { useState } from "react";
import { Box, Tooltip, Typography, Stack, Avatar } from "@mui/material";
import moment from "moment";
import appcolors from "../../../constants/Colors";
import { allImages, appFonts } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";

const TeacherEvents = ({ event }) => {
  const [open, setOpen] = useState(false);

  const toggleTooltip = (value) => {
    setOpen(value);
  };

  const start = moment(event.start);
  const end = moment(event.end);
  const duration = moment.duration(end.diff(start));
  const durationText = `${duration.hours() ? `${duration.hours()}h ` : ""}${
    duration.minutes() ? `${duration.minutes()}m` : ""
  }`;

  const commonTextStyle = {
    variant: "body1",
    fontSize: "0.75rem",
    lineHeight: "normal",
    fontFamily: "Roboto",
    lineHeight: 1.4,
  };

  const renderInsideView = () => (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onMouseEnter={() => toggleTooltip(true)}
      onMouseLeave={() => toggleTooltip(false)}
      onTouchStart={() => toggleTooltip(true)}
      className="custom-event"
      spacing={1}
    >
      <Stack direction="row" spacing={2} alignItems={"center"}>
        <Stack>
          <Stack spacing={1} direction="row" alignItems="center">
            <Typography {...commonTextStyle} fontSize="0.8rem">
              {`${start.format("h:mm A")} - ${end.format("h:mm A")}`}
            </Typography>
          </Stack>
          <Typography {...commonTextStyle}>{event.subject}</Typography>
          <Typography {...commonTextStyle} noWrap>
            Teacher: {event.teacherName}
          </Typography>
          <Typography {...commonTextStyle}>
            Duration: 1 hr
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );

  const renderTooltipView = () => (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={1}
        bgcolor={appcolors.primary}
        color={appcolors.white}
      >
        <Typography variant="body2">{`${start.format("h:mm A")} - ${end.format(
          "h:mm A"
        )}`}</Typography>
      </Stack>
      <Stack p={1.5} direction="row" alignItems="center" gap={1}>
        <Box>
          <Typography variant="body2">John Doe</Typography>
          <Typography
            variant="body2"
            fontSize="0.75rem"
            color={appcolors.charcolGrey}
          >
            johnDoe@gmail.com
          </Typography>
        </Box>
      </Stack>
      <Stack
        p={1}
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Typography {...commonTextStyle} fontSize="0.89rem" fontWeight={400}>
            {event.title}
          </Typography>
          <Typography {...commonTextStyle}>
            <strong>Status:</strong> {event.status}
          </Typography>
          <Typography {...commonTextStyle} color={appcolors.charcolGrey}>
            Duration: {durationText}
          </Typography>
        </Box>
        <Typography {...commonTextStyle} fontSize="0.89rem" fontWeight={400}>
          PKR {event.price || 0}
        </Typography>
      </Stack>
    </Box>
  );

  return (
    <Tooltip
      open={open}
      // title={renderTooltipView()}
      onClose={() => toggleTooltip(false)}
      onOpen={() => toggleTooltip(true)}
      disableHoverListener
      disableTouchListener
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": {
            padding: "0px",
            color: "#000000",
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
            borderRadius: "6px",
            overflow: "hidden",
            minWidth: "300px",
            maxWidth: "400px",
          },
        },
      }}
    >
      {renderInsideView()}
    </Tooltip>
  );
};

export default TeacherEvents;
